import"../dayjs.js";import dayjs from"../../node_modules/dayjs/dayjs.min.js";const isToday=dateTime=>{const date=typeof dateTime=="string"?dayjs(dateTime):dateTime;return date.isValid()?dayjs().isSame(date,"day"):!1};export{isToday};
